// dSPACE ValidationRules
import * as Yup from "yup";
import LocalizedStrings from 'react-localization';
import { ClientLanguage } from "../../../../Api"

let locStrings = new LocalizedStrings({
    de:
    {
        textRequired: "Angabe ist erforderlich",
        textValidationError: "Bitte geben Sie einen gültigen Wert an",
    },
    en:
    {
        textRequired: "Information required",
        textValidationError: "Please enter a valid value",
    }
});

function setLanguage(clientLanguage): void {
    switch(clientLanguage) { 
        case ClientLanguage.German: { 
           locStrings.setLanguage('de');
           break; 
        } 
        case ClientLanguage.English: { 
           locStrings.setLanguage('en'); 
           break; 
        } 
        // Otherwise "clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
    } 
}

export const characterRestrictionRegExp = /^[a-zA-Z0-9äöüÄÖÜßé '.,!?&_/\-()]+$/i;
export const characterRestrictionInDocNamesRegExp = /^[a-zA-Z0-9äöüÄÖÜßé '.,_\-()]+$/i;

export const checkText = (settings, clientLanguage) => Yup.string()
    .when("settings.isUnicode", {
        is: () => !settings.isUnicode,
        then: (schema) => {
            setLanguage(clientLanguage);
            return schema.matches(characterRestrictionRegExp, locStrings.textValidationError);
          },
    });

export const checkRequiredText = (settings, clientLanguage) => Yup.string()
    .when("InformationIsRequired", {
        is: () => true,
        then: (schema) => {
            setLanguage(clientLanguage);
            return schema.required(locStrings.textRequired);
          },
    })
    .when("settings.isUnicode", {
        is: () => !settings.isUnicode,
        then: (schema) => {
            setLanguage(clientLanguage);
            return schema.matches(characterRestrictionRegExp, locStrings.textValidationError);
          },
    });